import React, { useState } from "react";
import Img_logo from "../../assets/auth/logo.png";
import pass_on from "../../assets/auth/pass-on.png";
import pass_off from "../../assets/auth/pass-off.png";
import Styles from "../../styles/admin/login.module.scss";
import {  gymLoginService } from "../../services";
import { useNavigate } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (username.trim() && password.trim()) {
      const success = await gymLoginService(username, password);
      if (success) {
        navigate(adminRoutes.gym);
      }
    } else {
      console.log("An error occurred during login:");
    }
  };
  return (
    <div className={Styles.dashboard_main}>
      <div className={Styles.dashboard_flexmain}>
        <div className={Styles.flexdivider_2}>
          <div className={Styles.flexdivider_2_logo}>
            <img src={Img_logo} alt="admin_dash_logo" />
          </div>

          <div className={Styles.flexdivider_2_formcontainer}>
            <form autoComplete="" onSubmit={handleSubmit}>
              <div className={Styles.flexdivider_2_formcontainer_username}>
                <label className={Styles.label}>Username</label>
                <input
                  placeholder="Enter here"
                  required
                  type="username"
                  name="username"
                  minLength={2}
                  maxLength={50}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>

              <div className={Styles.flexdivider_2_formcontainer_password}>
                <label className={Styles.password}>Password</label>
                <input
                  placeholder="Enter here"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  required
                  minLength={2}
                  maxLength={50}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <div
                  type="button"
                  onClick={togglePasswordVisibility}
                  className={Styles.eyeIcon}
                >
                  <img
                    src={showPassword ? pass_on : pass_off}
                    alt="Toggle password visibility"
                    className={Styles.eyeImage}
                  />
                </div>
              </div>
              <br />
              <br />
              <div className={Styles.flexdivider_2_formcontainer_button}>
                <button type="submit">
                  <span>LOGIN</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
